import React from 'react';

function Footer() {
  return (
    <footer className="bg-dark text-white text-center py-3" style={{ width: '100%' }}>
      <a href="#" style={{ textDecoration: 'none', color: 'inherit' }}>
        &copy; All Rights Reserved by SASHI PAVAN
      </a>
    </footer>
  );
}

export default Footer;
